var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEnterOnVr = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 4A2.255 2.255 0 0 0 1 6.25v8.1a2.255 2.255 0 0 0 2.25 2.25h3.6c.714 0 1.38-.368 1.758-.974l1.37-2.19c.02-.033.024-.033.045 0l1.37 2.19a2.073 2.073 0 0 0 1.757.974h3.6A2.255 2.255 0 0 0 19 14.35v-8.1A2.255 2.255 0 0 0 16.75 4H3.25ZM6.4 6.7c1.486 0 2.7 1.214 2.7 2.7 0 1.486-1.214 2.7-2.7 2.7a2.707 2.707 0 0 1-2.7-2.7c0-1.486 1.214-2.7 2.7-2.7Zm7.2 0c1.486 0 2.7 1.214 2.7 2.7 0 1.486-1.214 2.7-2.7 2.7a2.707 2.707 0 0 1-2.7-2.7c0-1.486 1.214-2.7 2.7-2.7Z",
    fill: "currentColor"
  })));
};
export { SvgEnterOnVr as ReactComponent };